import styled from 'styled-components';
import Image from '../utils/Image/Image';

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 12rem);
`;

export const InfiniteScrollMarker = styled.div`
  min-height: 1rem;
`;

export const LoaderMoreContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 24rem;
  gap: 0.3rem;
  padding: 1.2rem 2.2rem 1.2rem 1.2rem;
  height: calc(100% - 12.4rem);
  overflow: auto;
  background: #f9fafb;
`;

export const MediaWrapper = styled.div`
  border-radius: 8px;
  overflow: hidden;
  height: 24rem;
  position: relative;
`;

export const StyledImage = styled(Image)`
  height: 100%;
  cursor: pointer;

  img {
    object-fit: cover;
  }
`;

export const PlayIconWrapper = styled.div`
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  /* background: rgba(0, 0, 0, 0.56); */
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const NotValidMedia = styled.div`
  position: absolute;
  background: rgba(0, 0, 0, 0.76);
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    color: #fff;
    text-align: center;
  }
`;

export const SelectIconWrapper = styled.button`
  position: absolute;
  top: 0.4rem;
  right: ${({ $notValid }) => ($notValid ? '3.8rem' : '0.4rem')};
  z-index: 1000;
  height: 3rem;
  width: 3rem;
  background-color: #00000060;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AiSellContainer = styled.div`
  position: absolute;
  top: 0.4rem;
  left: 0.4rem;
  z-index: 1000;
  height: 2rem;
  width: 2rem;
  background-color: #00000060;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
`;
